import React, {Component} from 'react';
import {Modal, Button, Row, Col}  from 'react-bootstrap'
import SecondServer from '../../database/SecondServer'
import { siteAccessCode } from '../../database/apiv2SiteAccessor';
import {addDevice} from '../../database/apiDevices'
import {sensorTypeName} from '../Measure/Sensors'
import {isEmpty} from '../../Utils/object'
import UnitsDropdown from './UnitsDropdown'
import MeterDropdown from './MeterDropdown'
import StyleDropdown from './StyleDropdown'
import HwDropdown from '../../Meters/HwData'
import TempDropdown from './TempDropdown'
import { addToCache, siteConfigUpdate } from '../../Sites/SiteConfig';
import { urlFactoryConfig } from '../../database/apiUrls';
import { PanelDots } from '../../Utils/PanelDots';

import { renderLoader } from '../../Loading/loading';

import '../report-header.css'
import './massedit.css'
import { typeToEditGroup, typeToLockedProps } from '../Measure/MeterTypes';
import { isplausibleFactor } from '../../Edit/validators';

export default class DeviceEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errMsg: '',
      changedInputs: [],
      dialogContent: 1,
      meter1: "Meter input 1",
      meter2: "Meter input 2",
      meter3: "Meter input 3",
      show: props.show ?? false,
      needSave: false,
      isLoading: false,
      loader: renderLoader(),
      closeOnly: false,
      factoryConfig: undefined,
    }
    this.saved = false;
    this.isNewDevice = true
    this.tempMeter1 = undefined
    this.tempMeter2 = undefined
    this.tempMeter3 = undefined
    this.radioIdLocked = this.props?.deviceId !== undefined
    this.deviceAttribs = ["node_id", "address", "building", "apt", "location_note"];
    this.meterAttribs = ["meter_type", "initial_meter_time", "meter_serial_number", "units",
                       "meter_style", "factor", "initial_meter_read", "note"];
    this.validations = {"radio-id": true};
    this.handleClose = this.handleClose.bind(this);
    this.validate = this.validate.bind(this);
    this.validateAndMoveOn = this.validateAndMoveOn.bind(this);
    this.validateAndSave = this.validateAndSave.bind(this)
    this.handleUnit = this.handleUnit.bind(this)
    this.handleMeter = this.handleMeter.bind(this)
    this.handleStyle = this.handleStyle.bind(this)
    this.handleTemp = this.handleTemp.bind(this)
    this.meterDefault = this.meterDefault.bind(this)
 
    this.leftNav = this.leftNav.bind(this)
  }
  componentDidUpdate(prevProps) {
    if (prevProps?.show !== this.props?.show) {
      this.defaultState();
      this.initStateFromProps ()
    }
  }

  defaultState () {
    this.setState ({errMsg: '', changedInput: [], dialogContent: 1, show: this.props?.show,
      meter1: "Meter input 1", meter2: "Meter input 2", meter3: "Meter input 3", closeOnly: false})
    this.validations = {"radio-id": true};
  }//needSave: false

  async initStateFromProps () {
    if (this.props?.deviceId) {
      this.setState({isLoading: true})
  
      const ss = new SecondServer(this.props)
      ss.apiData(urlFactoryConfig(this.props.deviceId)).then (cfg => 
        this.setState({factoryConfig: cfg?.data?.data}))
      let local = this.props.objMap.map ((item) => 
        ({property: item.to, value:this.props.meta[item.from]}))
      local.push ({property: "radio-id", value:this.props.deviceId })
      let sensors = []
      let meter1 = this.state.meter1
      let meter2 = this.state.meter2
      let meter3 = this.state.meter3
      if (this.props?.meta?.sensors && this.props.meta.sensors[0]) {
        local = this.initSensorState(local, this.props.meta)
        sensors.push(this.props.meta.sensors[0].sensor_type)
        meter1 = this.updateMeterName(this.props.meta.sensors[0].sensor_type, 1)
        sensors.push(this.props.meta.sensors[1].sensor_type)
        meter2 = this.updateMeterName(this.props.meta.sensors[1].sensor_type, 2)
        sensors.push(this.props.meta.sensors[2].sensor_type)
        meter3 = this.updateMeterName(this.props.meta.sensors[2].sensor_type, 3)
      }
      if (!this.hasMeter (local)) {
        local = await this.initStateFromAPI(local)
        meter1 = this.tempMeter1
        meter2 = this.tempMeter2
        meter3 = this.tempMeter3
      }
      this.radioIdLocked = true
      this.setState ({changedInputs: local, sensor_types: sensors, isLoading: false,
        meter1: meter1, meter2: meter2, meter3: meter3 })
      this.isNewDevice = false
      this.saved = false;
    }
    else
      this.isNewDevice = true
  }
  hasMeter (local) {
    return local.some(item=>this.meterAttribs.includes(item.property))
  }
  updateMeterName (typeCode, index) {
    const meter = sensorTypeName(typeCode)
    if (meter && meter !== typeCode) {
      if(/\d$/.test(meter))
        return meter
      else
        return meter+ ' '+index
    }
    return 'Meter input '+index
  }
  async initStateFromAPI (inputs) {
    if (this.props.deviceId && !this.hasMeter(inputs)) {
      const ac=siteAccessCode(this.props.getActiveSite());
      const url = "/tehama/sites/devices/"+this.props.deviceId+"/sensors?access_code="+ac
      const ss = new SecondServer(this.props);
      const resp = await ss.apiData(url)
      if (resp?.data?.data?.sensors && resp.data.data.sensors[0]) {
        inputs = this.initSensorState(inputs, resp?.data?.data)
        this.tempMeter1 = this.updateMeterName (resp.data.data.sensors[0]?.sensor_type, 1)
        this.tempMeter2 = this.updateMeterName(resp.data.data.sensors[1]?.sensor_type, 2)
        this.tempMeter3 = this.updateMeterName(resp.data.data.sensors[2]?.sensor_type, 3)
      }
    }
    return inputs
  }
  initSensorState (state, apiData) {
    state = state.concat (this.meterAttribs.map ((item) => 
      ({property: item, value:apiData?.sensors[0][item], seq: '1'})))
    if (apiData?.sensors && apiData?.sensors?.length > 1) {
      state = state.concat (this.meterAttribs.map ((item) => 
        ({property: item, value:apiData?.sensors[1][item], seq: '2'})))
    }
    return state
  }

  jsonifyInputs(arrList) {
    let result= {};
    arrList.forEach(element => {
      const field = this.findChange (element);
      if (field !== null)
        result[field.property] = field.value;
    });
    return result;
  }

  jsonifyIndexed(arrList, index) {
    let result= {};
    arrList.forEach(element => {
      const field = this.findNumberedChange (element, index);
      if (field !== null)
        result[field.property] = field.value;
    });
    return result;
  }

  async saveMeter (ss, ac, radio_id, index)
  {
    const saveObj = this.jsonifyIndexed(this.meterAttribs, index.toString());
    if (!isEmpty(saveObj)) {
      //console.log ("meter ",saveObj);
      const url = "/tehama/sites/devices/"+radio_id+"/sensors/"+(index-1)+"?access_code="+ac
      const resp = await ss.apiSaveData(url, saveObj);
      /*if (404 === apiStatus(resp)) {
        console.log ("trying add")
        const newResp = await ss.apiInsertData(url, saveObj)
      } */
      if (ss.getErrorMsg()) {
        this.setState ( {errMsg: ss.getErrorMsg()} );
        return false
      }
    }
    return true
  }

  async saveChanges() {
    if (!this.state.needSave) {
      return true
    }
    const ac=siteAccessCode(this.props.getActiveSite());
    const field = this.findChange("radio-id");
    const ss = new SecondServer(this.props);
    let retcode = true
    if (this.isNewDevice || this.props?.mdtOnly==='true') {
      const resp = await addDevice (ac, field.value, ss)
      const msg = ss.getErrorMsg()
      if (msg) {
        this.setState({errMsg: msg})
        return false
      }
      addToCache(this.props, field.value)
      const warn = resp?.data?.data?.result?.message
      if (warn) {
        this.setState({errMsg: warn, closeOnly: true})
        retcode = false
      }
    }

    const url = '/tehama/sites/devices/'+field.value+'?access_code='+ac
    const saveObj = this.jsonifyInputs(this.deviceAttribs);
    console.log ("save ", saveObj)
    await ss.apiSaveData(url, saveObj, true); //add params to device
    siteConfigUpdate(this.props, field.value, saveObj)
    if (this.props?.mdtOnly==='true')
      return retcode

    this.saved = retcode & await this.saveMeter (ss, ac, field.value, 1)
    this.saved &= await this.saveMeter (ss, ac, field.value, 2);
    return this.saved
  }

  async handleClose() {
    this.setState ({show: false});
    const newState = {onOff: false, deviceId: null, refresh: this.saved,}
    this.props.onHide(newState);
  }

  handleChange = event => {
    const item = event.target
    const stateData = {property:item.id, value: item.value, ...(item.dataset?.seq && {seq: item.dataset.seq}) }
    const changedIndex = item.dataset?.seq ? this.findNumberedChangeIndex(item.id, item.dataset.seq) : 
      this.findChangeIndex(item.id)
    let temp = this.state.changedInputs.slice(0);
    changedIndex >= 0 ? temp[changedIndex] = stateData : temp.push(stateData);
    this.setState({changedInputs: temp, needSave: true})
  }

  handleUnit (value) {
    this.persistEdit (value, "units")
  }
  handleMeter(value) {
    this.persistEdit (value, "meter_type")
  }
  handleStyle(value) {
    this.persistEdit (value, "meter_style")
  }
  handleTemp(value) {
    this.persistEdit(value, "units")
  }
  persistEdit (value, prop) {
    const strseq = (this.state.dialogContent-1).toString()
    const stateData = {property:prop, value: value, seq: strseq}
    const changedIndex = this.findNumberedChangeIndex(prop, strseq)
    let temp = this.state.changedInputs
    changedIndex >=0 ? temp[changedIndex] = stateData : temp.push(stateData)
    this.setState({changeInputs: temp, needSave: true})
  }
  findChange(id) {
    const changedIndex = this.findChangeIndex(id);
    return changedIndex >= 0 ? this.state.changedInputs[changedIndex] : null;
  }

  findChangeIndex(id) {
    return this.state.changedInputs.findIndex(item => item.property === id)  
  }

  findNumberedChange(id, index) {
    const changedIndex = this.findNumberedChangeIndex(id, index);
    return changedIndex >=0 ? this.state.changedInputs[changedIndex] : null;
  }

  findNumberedChangeIndex(id, index) {
    return this.state.changedInputs.findIndex(item => item.property === id && item?.seq === index)
  }

  validate () {
    const fieldName = 'radio-id'
    const field = this.findChange(fieldName);
    if (field?.value?.length !== 8) {
      this.validations[fieldName] = false;
      return "Radio Id needs to be 8 characters long"
    }
    
    const re = /[0-9A-Fa-f]{8}/g;
    if(!re.test(field.value)) {
      this.validations[fieldName] = false;
      return "Radio Id should be only hex digits";
    }
    this.validations[fieldName] = true;

    const msg = this.validFactor()
    if (msg.length)
      return msg

    if (!this.validIndexedNumber("initial_meter_read"))
      return "Initial Meter Reading must be numeric or blank"

    return null;
  }
  validFactor() {
    const field = this.getIndexedNumber('factor')
    const msg = isplausibleFactor(field?.value)
    this.validations['factor'] = msg?.length === 0
    return msg.length > 0 ? "Count factor "+ msg : msg
  }
  validIndexedNumber (fieldName) {
    const field = this.getIndexedNumber(fieldName)
    if (field?.value) {
      const reNum = /^[+-.]?\d+(\.\d+)?$/
      this.validations[fieldName] = reNum.test(field.value)
      return this.validations[fieldName]
    }
    this.validations[fieldName] = true
    return true   //blank is ok too
  } 
  getIndexedNumber(fieldName) {
    const pg = (this.state.dialogContent-1).toString()
    const field = this.findNumberedChange(fieldName, pg)
    return field
  }
  async moveOn (msg) {
    const page = this.state.dialogContent;
    if (page < 4) {
      this.setState({dialogContent: page+1});
    }
    else {
      this.saveAndClose()
    }
  }
  async saveAndClose() {
    if (await this.saveChanges()) {
      this.handleClose()
    if (this.props.onChange && this.state.needSave)
      this.props.onChange(this.state)
    }
    else {
      this.setState({isLoading: false}) 
    }
  }
  moveBack() {
    const msg = this.validate();
    this.setState({errMsg: msg}) 
    if (msg) return

    const page = this.state.dialogContent;
    if (page > 1)
      this.setState({dialogContent: page-1});  
  }

  validateAndMoveOn() {
    const msg = this.validate();
    this.setState({errMsg: msg}) 
    if (msg === null) 
      this.moveOn ()
  }
  validateAndSave() {
    if (this.state.closeOnly) {
      this.handleClose()
    }
    else {
      const msg = this.validate();
      this.setState({errMsg: msg, isLoading: msg === null}) 
      if (msg === null) 
        this.saveAndClose ()
    }
  }
  leftBreadcrumb () {
    const page = this.state.dialogContent;
    return (
      <>
      <span id="dcNav1" className={page === 1 ? "selected" : "notselected"} onClick={this.leftNav}
        key="tab1">Device Configuration<br />
      </span>
      <span id="dcNav2" className={page === 2 ? "selected" : "notselected"} onClick={this.leftNav}
        key="tab2">{this.state.meter1}<br />
      </span>
      <span id="dcNav3" className={page === 3 ? "selected" : "notselected"} onClick={this.leftNav}
        key="tab3">{this.state.meter2}<br/>
      </span>
      <span id="dcNav4" className={page === 4 ? "selected" : "notselected"} onClick={this.leftNav}
        key="tab4">{this.state.meter3}
      </span>
      </>
    )
  }
  leftNav(evt) {
    const pageMap = {'dcNav1': 1, 'dcNav2': 2, 'dcNav3': 3, 'dcNav4': 4}
    const wanted = pageMap[evt?.target?.id]
    if (wanted && wanted !== this.state.dialogContent) {
      const msg = this.validate();
      this.setState({errMsg: msg}) 
      if (!msg) 
        this.setState({dialogContent: wanted})
    }
  }

  sequenceDots () {
    if (this.props?.mdtOnly === 'true' || (!this.state.meter1))
      return <div className="dot-placement">&nbsp;</div>
    return (
      <div className="dot-placement">
        <PanelDots selected={this.state.dialogContent-1} count={4}/>
      </div>
    )
  }
  renderCurrentTab() {
    if (this.state.isLoading) return this.state.loader;
    switch (this.state.dialogContent) {
      case 1:
      default:
        return this.renderTab1();
      case 2:
        return this.renderMeterTab(this.state.meter1, 1);
      case 3:
        return this.renderMeterTab(this.state.meter2, 2);
      case 4:
        return this.renderMeterTab(this.state.meter3, 3)
    }
  }

  appendRadioId(to) {
    const fieldName = 'radio-id'
    const field = this.findChange(fieldName);
    const result = (field?.value?.length === 8) ? to + ' for '+field.value: to 
    return result
  }
  renderHeader(title, addInfo='') {
    return (
      <Modal.Header closeButton>
        <Modal.Title>{title}
          <span className='title-small'>{addInfo}</span>
        </Modal.Title>
      </Modal.Header>
    )    
  }
  
  inputBorder(valid) {
    return valid ? "input-ok" : "input-issue";
  }

  inputCommon (element, id, prompt) {
    return (
      <Col md="4" className="label-item">
        <label htmlFor={id}>{prompt}</label>
        {element}
      </Col>
    )
  }
  inputField(toDisplay, id, prompt, bcolor, locked=false) {
    const color = locked ? '' : bcolor
    return (this.inputCommon (
       <input className={"compact-item "+color} type="text" value={toDisplay} id={id}
          onChange={this.handleChange} disabled={locked} size="25"/>, id, prompt
    ))
  }
  modalInput (id, prompt, valid=true) {
    const bcolor = this.inputBorder(valid);
    const prev_item = this.findChange(id)
    const toDisplay = prev_item ? prev_item.value : ""
    return this.inputField(toDisplay, id, prompt, bcolor)
  }

  modalIndexedInput (id, prompt, index, valid=true, locks=[]) {
    const locked = locks.includes(id)
    const bcolor = locked ? '' : this.inputBorder(valid);
    const prev_item = this.findNumberedChange(id, index.toString())
    const toDisplay = prev_item ? prev_item.value : ""
    return (this.inputCommon (
      <input className={"compact-item "+bcolor} type="text" value={toDisplay} id={id} data-seq={index} 
        onChange={this.handleChange} disabled={locked} />, id, prompt
    ))
  }
  modalIndexedUnits (id, prompt, index, valid=true, locks=[]) {
    const locked = locks.includes(id)
    const prev_item = this.findNumberedChange(id, index.toString())
    const toDisplay = prev_item?.value
    return this.inputCommon(
      <UnitsDropdown anchorStyle="dropdown-anchor" id={id} value={toDisplay} 
        onUpdate={this.handleUnit} disabled={locked} />, id, prompt
    )
  }
  modalIndexedMeter (id, prompt, index, valid=true) {
    const prev_item = this.findNumberedChange(id, index.toString())
    const toDisplay = prev_item?.value
    return this.inputCommon(
      <MeterDropdown anchorStyle="dropdown-anchor" id={id} value={toDisplay} onUpdate={this.handleMeter} />, id, prompt
    )
  }
  modalIndexedStyle (id, prompt, index, valid=true) {
    const prev_item = this.findNumberedChange(id, index.toString())
    const toDisplay = prev_item?.value
    return this.inputCommon(
      <StyleDropdown anchorStyle="dropdown-anchor" id={id} value={toDisplay} onUpdate={this.handleStyle} />, id, prompt
    )
  }
  modalIndexedTemperature (id, prompt, index, valid=true, locks=[]) {
    const locked = locks.includes(id)
    const prev_item = this.findNumberedChange(id, index.toString())
    const toDisplay = prev_item?.value
    return this.inputCommon(
      <TempDropdown anchorStyle="dropdown-anchor" id={id} value={toDisplay} 
        onUpdate={this.handleTemp} disabled={locked} />, id, prompt
    )
  }
  radioInput (id, prompt, valid=true) {
    const bcolor = this.inputBorder(valid);
    const prev_item = this.findChange(id)
    const toDisplay = prev_item ? prev_item.value : ""
    return this.inputField (toDisplay, id, prompt, bcolor, this.radioIdLocked)
  }
  showDefaults (type) {
    const group = typeToEditGroup(type)
    if (group === 'modbus') return null
    return (
      <Row className="label-item meter-input">
        <Col md="4" className="label-item">
          Apply defaults for meter
        </Col>
        <Col md="4">
          <HwDropdown onUpdate={this.meterDefault}/>
        </Col>
      </Row>
    )
  }
  meterDefault(param) {
    this.persistEdit (param.factor, "factor")
    const util = param?.utility.split("-")
    if (util) {
      this.persistEdit(util[0], "meter_type")
      if (util.length > 1)
        this.persistEdit (util[1], "meter_style")
    }
  }
  renderMeterBody(seq) {
    if (!this.state?.sensor_types) {
      return <Modal.Body> </Modal.Body>
    }
    if (1 === parseFloat(this.state?.sensor_types[seq-1])) {
      return(
        <Modal.Body>
        <Row className='mt-4'>
          {this.modalIndexedTemperature('units', "Units", seq, true, []) }
        </Row>
        </Modal.Body>
      )
    }
    const locks = typeToLockedProps(this.state?.sensor_types[seq-1])
    return(
      <Modal.Body>
      {this.showDefaults(this.state?.sensor_types[seq-1])}
      <Row className='mt-4'>
        {this.modalIndexedMeter('meter_type', 'Type', seq)}
        <Col md="1"></Col>
        {this.modalIndexedUnits('units', 'Unit', seq, true, locks)}
      </Row>

      <Row className='mt-4'>
        {this.modalIndexedStyle('meter_style', 'Style', seq)}
        <Col md="1"></Col>
        {this.modalIndexedInput('factor', 'Count Factor', seq, 
          this.validations["factor"], locks)}
      </Row>

      <Row className='mt-4'>
        {this.modalIndexedInput('initial_meter_time', 'Initial Time', seq)}
        <Col md="1"></Col>
        {this.modalIndexedInput('initial_meter_read', 'Initial Meter Reading', 
          seq, this.validations["initial_meter_read"])}
      </Row>

      <Row className='mt-4'>
        {this.modalIndexedInput('meter_serial_number', 'Serial Number', seq, true, locks)}
        <Col md="1"></Col>
        {this.modalIndexedInput('note', 'Notes', seq, true, locks)}
      </Row>
    </Modal.Body>
    )
  }
  renderFooter() {
    const nextDisabled = (this.props?.mdtOnly === 'true') || this.state.dialogContent === 4
      || (!this.state.meter1)
    const btnText = this.state.closeOnly ? "Close" : "Save"
    return(
      <Modal.Footer>
        <div className="modal-error">{this.state.errMsg}</div>
        {this.state.dialogContent > 1 ?
          <Button className="custom-btn-cancel" onClick={()=>this.moveBack()}>Previous</Button>
          : null}
        {nextDisabled ? null :
          <Button className="custom-btn-cancel" onClick={()=>this.validateAndMoveOn()}>Next</Button>}
        <Button className="custom-btn-cancel" onClick={()=>this.handleClose()}>Cancel</Button>
        <Button className="custom-ok-btn" onClick={()=>this.validateAndSave()}>{btnText}</Button>
      </Modal.Footer>
    )    
  }
  renderMeterTab(name, index) {
    return( 
      <div className="modal-right">
        {this.renderHeader (this.appendRadioId(name))}
        {this.renderMeterBody(index)}
        {this.sequenceDots()}
        {this.renderFooter()}
      </div>
    )
  }
  renderTab1() {
    const model = this.state.factoryConfig?.Config_As ?? ''
    const disp = model ? " Model - "+model : ''
    return(
      <div className="modal-right">
        {this.renderHeader("Device Configuration", disp)}
        <Modal.Body>
        <Row className='mt-4'>
          {this.radioInput('radio-id', 'Radio ID', this.validations["radio-id"])}
          <Col md="1"></Col>
          {this.modalInput('node_id', 'Node ID', true)}
        </Row>

        <Row className='mt-4'>
          {this.modalInput('address', 'Address', true)}
          <Col md="1"></Col>
          {this.modalInput('building', 'Building', true)}
        </Row>

        <Row className='mt-4'>
          {this.modalInput('apt', 'Apt', true)}
          <Col md="1"></Col>
          {this.modalInput('location_note', 'Location Note', true)}
        </Row>

      </Modal.Body>
      {this.sequenceDots()}
      {this.renderFooter()}
    </div>
    )
  }
  render() {
    return(
      <Modal show={this.state.show} onHide={this.handleClose} size="lg">
        <div className="device-modal">
          <div className="modal-left">{this.leftBreadcrumb()}</div>
          {this.renderCurrentTab()}
        </div>
      </Modal>
    )
  }
}  
